import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-generic-dialog-box',
  templateUrl: './generic-dialog-box.component.html',
  styleUrls: ['./generic-dialog-box.component.scss']
})
export class GenericDialogBoxComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) { }
}